import React, { useState, useEffect } from "react";
import YhInput from "../../../../../ui/YhInput";
import YhButton from "../../../../../ui/YhButton";
import customErrorHandler from "../../../../../utils/customErrorHandler";
import { isTruthy, openErrorNotification, openSuccessNotification } from "../../../../../helpers/methods";
import notifiers from "../../../../../global/constants/NotificationConstants";
import { getBankDetails, saveBankDetails, saveOfficialInfo, updateBankInfo } from "../StepperService";
import CustomLoader from "../../../../../global/components/CustomLoader/CustomLoader";
const _ = require("lodash");

interface CustomProps {
  nextStep?: () => void | undefined;
  userId: String;
  backStep?: () => void | undefined;
  fromSettingOrLogout?: any;
  registerStepActions?: (actions: { submit: () => void | Promise<void> }) => void;
  hideFooterButtons?: boolean;
}

let clonedObject = {};

const BankInformation = (props: CustomProps) => {
  const [apiResponse, setApiResponse] = useState(false);
  const [dataFlag, setDataFlag] = React.useState<Number>(0);

  const [bankInfo, setBankInfo] = useState<any>({});

  const handleOnChangeInputField = (event: React.ChangeEvent<any>) => {
    setBankInfo({
      ...bankInfo,
      [event.target.name]: event.target.value,
    });
  };

  useEffect(() => {
    init();
  }, []);

  const handleBackBtn = () => {
    props.backStep?.();
  };

  const init = async () => {
    if (props.userId) {
      try {
        setApiResponse(true);
        const response = await getBankDetails(props.userId);
        customErrorHandler(response);
        setBankInfo(response.data);
        setDataFlag(response.success ?? 0);
        clonedObject = _.cloneDeep(response.data);
        setApiResponse(false);
      } catch (error: any) {
        setApiResponse(false);
        {
          error.message !== "Data not found" && openErrorNotification(isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR);
        }
      }
    }
  };

  const submitForm = async () => {
    if (_.isEmpty(bankInfo)) {
      props.nextStep?.();
      return;
    }
    if (props.userId && _.isEqual(clonedObject, bankInfo) && dataFlag) {
      props.nextStep?.();
    } else if (props.userId && dataFlag) {
      try {
        setApiResponse(true);
        const body = { ...bankInfo };
        body.id = body._id;
        const response = await updateBankInfo(body);
        if (response?.success) {
          setBankInfo(response.data);
          openSuccessNotification(response?.message);
          props.nextStep?.();
        } else {
          customErrorHandler(response);
        }
        setApiResponse(false);
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR);
      }
    } else {
      try {
        setApiResponse(true);
        const body = { ...bankInfo, userId: props.userId };
        const response = await saveBankDetails(body);
        if (response?.success) {
          setBankInfo(response.data);
          openSuccessNotification(response?.message);
          props.nextStep?.();
          setApiResponse(false);
        } else {
          customErrorHandler(response);
        }
        setApiResponse(false);
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR);
      }
    }
  };

  useEffect(() => {
    props.registerStepActions?.({ submit: submitForm });
  });

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const inputs = document.getElementsByTagName("input");
      const currentIndex = Array.from(inputs).indexOf(
        event.target as HTMLInputElement
      );
      const nextIndex = currentIndex + 1;

      if (nextIndex < inputs.length) {
        inputs[nextIndex].focus();
      } else {
        // If the last input field is reached, trigger the submitForm function
        submitForm();
      }
    }
  };

  return (
    <div className="w-full">
      <div className="mb-5">
        <h2 className="text-lg font-semibold text-[#111827]">Bank Information</h2>
        <p className="mt-1 text-sm text-[#6B7280]">
          Update your Bank information for the platform
        </p>
      </div>

      <div className="mb-6 mt-5">
        <h3 className="text-base font-semibold text-[#111827]">Bank Details</h3>
        <p className="mt-1 text-sm text-[#6B7280]">
          {props.fromSettingOrLogout === "fromSettingOrLogout"
            ? "Manage your bank information"
            : "Manage bank information"}
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <YhInput
          onKeyPress={handleKeyPress}
          label="Bank Name"
          placeholder="State Bank Limited"
          value={bankInfo.bank_name || ""}
          onChange={handleOnChangeInputField}
          name="bank_name"
        />

        <YhInput
          onKeyPress={handleKeyPress}
          label="Branch Name"
          placeholder="Delhi"
          value={bankInfo.branch_name || ""}
          onChange={handleOnChangeInputField}
          name="branch_name"
        />

        <YhInput
          onKeyPress={handleKeyPress}
          label="Account Holder Name"
          placeholder="State Bank Limited"
          value={bankInfo.holder_name || ""}
          onChange={handleOnChangeInputField}
          name="holder_name"
        />

        <YhInput
          type="number"
          label="Account Number"
          placeholder="XXXXXXXXXXXX"
          value={bankInfo.account_no || ""}
          onChange={handleOnChangeInputField}
          name="account_no"
          maxLength={10}
          onKeyPress={handleKeyPress}
        />

        <YhInput
          onKeyPress={handleKeyPress}
          label="IFSC Code"
          placeholder="XXXXXXXXXXXX"
          value={bankInfo.ifsc || ""}
          onChange={handleOnChangeInputField}
          name="ifsc"
        />

        <div className="mt-2 flex flex-wrap gap-3 lg:col-span-2">
          {props.hideFooterButtons ? null : (
            <>
              <YhButton variant="secondary" onClick={handleBackBtn}>
                Back
              </YhButton>
              <YhButton variant="primary" onClick={submitForm}>
                Save & Continue
              </YhButton>
            </>
          )}
        </div>
      </div>

      {apiResponse && <CustomLoader apiResponse={false} />}
    </div>
  );
};

export default BankInformation;
